export default {
  IS_CHANGE_STATUS: false
};



// WEBPACK FOOTER //
// ./src/util/call/kt/ktAPI/ktCommon.js